import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { request } from '@/utils';
  import urlJoin from 'url-join';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  async function login() {
    const { data } = await request.get('/auth/sso_token');
    window.location.href = urlJoin(process.env.VUE_APP_PARTNER_SITE_ORIGIN, `/sso/${data.sso_token}`);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", { onClick: login }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})